import React from "react";

import { IgChip } from "@intelligems/ig-theme";
import { Chip } from "@mui/material";

export const LegacyBadge = () => {
  return <IgChip label={"Legacy Subscriptions"} size={"small"} />;
};
